import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/analytics';
import 'firebase/storage';
import 'firebase/functions';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyClM79JIZlbUvHdZKG0iBPiqJt2kZa4nPk',
  authDomain: 'schoolblocks-platform-dev.firebaseapp.com',
  databaseURL: 'https://schoolblocks-platform-dev.firebaseio.com',
  projectId: 'schoolblocks-platform-dev',
  storageBucket: 'schoolblocks-platform-dev.appspot.com',
  messagingSenderId: '109177726546',
  appId: '1:109177726546:web:e35dff1a34c49644d8218b',
});

export const db = firebaseApp.firestore();
export const auth = firebaseApp.auth();

const ui = new firebaseui.auth.AuthUI(auth);
export const renderAuthUI = (element: Element) => {
  ui.start(element, {
    signInFlow: 'popup',
    signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
    callbacks: {
      signInSuccessWithAuthResult: function() {
        return true;
      },
    },
  });
};

export const observeUser = (observer: (user: firebase.User | null) => void) =>
  auth.onAuthStateChanged(observer);

export function getUser() {
  return auth.currentUser;
}

export const signOut = async () => await auth.signOut();

export default firebaseApp;
